import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Button, Typography } from 'seagull';
import { ColorAnchor } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { useCreateVendorAccount } from '~/hooks/useCreateVendorAccount/useCreateVendorAccount';
import { useLocaleKeys } from '~/i18n';
import styles from './TryAnchorBanner.module.scss';
export const GetTryAnchorBannerTID = (parentTestId)=>getTestIds(parentTestId);
export const TryAnchorBanner = (param)=>{
    let { testId } = param;
    const { TryAnchorBannerTestIds } = useMemo(()=>GetTryAnchorBannerTID(testId), [
        testId
    ]);
    const { t } = useLocaleKeys();
    const onCreateVendorAccount = useCreateVendorAccount();
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": TryAnchorBannerTestIds.Root(),
        className: styles.banner,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: styles.bannerContent,
                children: [
                    /*#__PURE__*/ _jsx(ColorAnchor, {
                        size: 56
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "h6",
                                weight: "normal",
                                children: t.invoice.adHocApproval.confirmation.tryAnchorBanner()
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "paragraph1",
                                weight: "light",
                                testId: TryAnchorBannerTestIds.Subtitle(),
                                children: t.invoice.adHocApproval.confirmation.tryAnchorSubtitle()
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Button, {
                bi: {
                    name: 'ad_hoc_invoice_try_anchor'
                },
                testId: TryAnchorBannerTestIds.Cta(),
                className: styles.bannerCta,
                skin: "primaryOutline",
                onClick: onCreateVendorAccount,
                children: [
                    t.invoice.adHocApproval.confirmation.getStartedFree(),
                    /*#__PURE__*/ _jsx("span", {
                        "aria-hidden": "true",
                        children: " →"
                    })
                ]
            })
        ]
    });
};
